'use client';
import PaymentGuardianIcon from '@/components/customercenter-ui/svgs/paymentGuardian';
import { PaymentGuardianData } from '../../customer-detail/types';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const PaymentGaurdianDetailsModal = ({
  Texts,
  paymentGuardianData,
  open,
  setOpen,
}: {
  Texts: any;
  paymentGuardianData: PaymentGuardianData;
  open: boolean;
  setOpen: any;
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
      }}
    >
      <DialogContent className="max-w-[466px] bg-white sm:rounded-md">
        <DialogHeader>
          <DialogTitle className="flex justify-center text-2xl font-bold">
            <PaymentGuardianIcon />
          </DialogTitle>
        </DialogHeader>
        <section className="my-4 max-h-[360px] overflow-y-auto px-2 text-center">
          <p className="font-bold">{Texts.contactProgramAdmin}</p>
          <p className="my-2">{Texts.questionClaimOrStatus}</p>
          <p className="mb-4">
            <span className="font-bold">{Texts.benefitDirect}</span> {paymentGuardianData?.benefitsDirect}
          </p>
          <p>{Texts.genralQuestion}</p>
          <p className="my-4">
            <span className="font-bold">{Texts.customerCare}</span> {paymentGuardianData?.customerCare}
          </p>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentGaurdianDetailsModal;
